module.exports = __webpack_public_path__ + "static/media/google.f2ed7ab9.svg";